import React from 'react';
import { Link } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilCaretRight } from '@coreui/icons';
import { CCard, CCardBody } from '@coreui/react';

/**
 * Balance widget showing total balance with payout option
 */
const BalanceWidget = () => {
      return (
            <CCard className="balance-widget">
                  <CCardBody className="d-flex justify-content-between align-items-start">
                        <div className="balance-info">
                              <div className="balance-label">Total balance</div>
                              <div className="balance-amount">$1,532</div>
                        </div>
                        <Link
                              to="/dashboard/creator/payouts"
                              className="payout-link"
                        >
                              Pay out to bank
                              <CIcon icon={cilCaretRight} size="sm" className="ms-1" />
                        </Link>
                  </CCardBody>
            </CCard>
      );
};

export default BalanceWidget; 